import { getHandler } from 'src/utils/fetchHandler';

export const GET_NOTE_TYPES = 'GET_NOTE_TYPES/NOTE_TYPES/@WISELY/WEB';
export const FETCH_NOTE_TYPES_FAILED = 'FETCH_NOTE_TYPES_FAILED/NOTE_TYPES/@WISELY/WEB';
export const FETCH_NOTE_TYPES_SUCCEEDED = 'FETCH_NOTE_TYPES_SUCCEEDED/NOTE_TYPES/@WISELY/WEB';

export const getNoteTypes = () => ({
	type: GET_NOTE_TYPES,
});

export const fetchNoteTypesFailed = payload => ({
	type: FETCH_NOTE_TYPES_FAILED,
	payload,
});

export const fetchNoteTypesSucceeded = payload => ({
	type: FETCH_NOTE_TYPES_SUCCEEDED,
	payload,
});

export const fetchNoteTypes = () => {
	return dispatch => {
		dispatch(getNoteTypes());
		const path = `v1/note_types`;

		return getHandler(path)
			.then(json => dispatch(fetchNoteTypesSucceeded(json)))
			.catch(error => {
				console.error('fetchNoteTypes error', error);
				dispatch(fetchNoteTypesFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/noteTypes/noteTypes.action.js